<template>
    <v-container  class="align-start mt-3">
        <v-row align="center">
            <v-col align="center">
                <h3>{{ player? player.name: "" }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <elo-chart :chartData="elos" :labels="dates"></elo-chart>

            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import EloChart from '../components/EloChart'
import { format } from 'date-fns'
    export default {
        name: "Player",
        components: {
            EloChart                
        },
        data() {
            return {
                player: null,
                elos: [],
                dates: []
            }
        },
        methods: {
            getElos(){
                if(this.elos.length == 0){
                    this.player = this.$store.state.players.find(item => item.id == this.$route.params.id)                        
                    let myGames = this.allGames.filter(a => a.players.find((item) => item.id == this.$route.params.id) != undefined)                        
                    for(let game of myGames){                            
                        let temp = game.players.find(item => item.id == this.player.id)
                        if(temp && temp.elo){                            
                            this.elos.push(temp.elo)
                            this.dates.push(format(new Date(game.date), 'dd.MM.yyyy'))
                        } 
                    }
                    this.elos.push(this.player.score? this.player.score : this.player.elo)
                    this.dates.push(format(new Date(), 'dd.MM.yyyy'))
                }
            }
        },
        mounted(){
            this.getElos()
        },
        watch: {
            allGames: {
                deep: true,
                handler(){                    
                    this.getElos()
                }
            }
        },
        computed: {
            ...mapGetters(['allGames']),
        }
    }
</script>

<style lang="scss" scoped>

</style>